import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({})

class PlayerModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    player: PropTypes.object,
    updatePlayer: PropTypes.func,
    createPlayer: PropTypes.func,
    playerNames: PropTypes.array,
    hideModal: PropTypes.func
  }
  static defaultProps = {
    playerNames: []
  }
  state = {
    player: {
      name: '',
      reduc: '',
      order: 1,
      show: true
    },
    isValid: false,
    errors: {}
  }
  updateState = nextState => {
    const { player } = nextState
    const playerProps = this.props.player
    let isValid = true
    let errors = {}
    if (
      !playerProps &&
      this.props.playerNames.includes(_.lowerCase(player.name))
    ) {
      isValid = false
      errors.name = 'Un autre type de joueur existe déjà avec ce nom'
    }
    if (player.reduc === '') {
      isValid = false
      errors.type = 'Ce champs est requis'
    }
    if (playerProps && isValid) {
      isValid = !_.isEqual(playerProps, player)
    }
    this.setState({ ...nextState, isValid, errors })
  }
  handleChange = name => (e, val) => {
    const isChecker = e.target.value === 'checker'
    let value = isChecker ? e.target.checked : val || e.target.value
    this.updateState({
      ...this.state,
      player: { ...this.state.player, [name]: value }
    })
  }
  handleOnCreate = () => {
    const { player } = this.state
    this.props.createPlayer(player)
  }
  handleOnUpdate = () => {
    const { player } = this.state
    this.props.updatePlayer(this.props.player, player)
  }
  showSwitch = classes => {
    const { player } = this.state
    return (
      <FormControlLabel
        control={
          <Switch
            checked={player.show}
            onChange={this.handleChange('show')}
            value="checker"
            color="primary"
          />
        }
        label="Afficher"
      />
    )
  }
  componentDidMount() {
    const { player } = this.props
    let nextState = { ...this.state }
    if (player) {
      nextState = { player: { ...player } }
    }

    this.updateState(nextState)
  }
  render() {
    const { classes } = this.props
    const { errors, isValid, player } = this.state
    const isCreate = !this.props.player
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={isCreate ? this.handleOnCreate : this.handleOnUpdate}
        title={isCreate ? 'Ajouter un tarif' : `Editer ${player.name}`}
        okDisabled={!isValid}>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
            item
            xs={12}
            sm={12}
            md={6}>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="name"
                error={!!errors.name}
                helperText={errors.name || null}
                required
                label="Nom"
                disabled={!isCreate && _.lowerCase(player.name) === 'normal'}
                onChange={this.handleChange('name')}
                value={player.name}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <TextField
                id="reduc"
                error={!!errors.name}
                helperText={errors.name || null}
                required
                label="Réduction (%)"
                onChange={this.handleChange('reduc')}
                value={player.reduc}
                type="number"
                inputProps={{ min: '0', max: '100' }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              {this.showSwitch(classes)}
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(PlayerModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Players/components/PlayerModal.js